import { browserHistory } from 'react-router';

/**
 * Applies dashboard URL-query defaults so list fetches use a consistent tab filter.
 * @param {Object} [query={}] - Route query from react-router (e.g. type, page, search)
 * @returns {Object} Query with `type` defaulting to `my-reports` when omitted
 */
export function normalizeDashboardFilters(query = {}) {
    return {
        ...query,
        // Default reports tab when /reports has no ?type= in the URL
        type: query.type || 'my-reports',
    };
}

/**
 * Reads the current route query and normalizes dashboard filter defaults.
 * Used after editor save/close so dashboard reload matches the user's URL state.
 * @returns {Object} Normalized dashboard filters from browserHistory
 */
export function getDashboardFiltersFromLocation() {
    const query = browserHistory.getCurrentLocation().query || {};
    return normalizeDashboardFilters(query);
}
